import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { NotificationServiceService } from './../../../../../services/notification-service/notification-service.service';
import { UsersService } from './../../../../../services/API/users/users.service';
import { NewUserComponent } from './components/new-user/new-user.component';
import { ConfirmDialogComponent } from './../../../shared/components/confirm-dialog/confirm-dialog.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { EditUserPasswordComponent } from './components/edit-user-password/edit-user-password.component';
import { XlsxService } from './../../../shared/xlsx/xlsx.service';
import { AuthService } from './../../../../../services/API/auth/auth.service';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
    selector: 'app-gestion-usuarios',
    templateUrl: './gestion-usuarios.component.html',
    styleUrls: ['./gestion-usuarios.component.css'],
    standalone: false
})
export class GestionUsuariosComponent implements OnInit {

  loadingBar: boolean = true;
  displayedColumns = ['id', 'name', 'surname', 'email', 'active'];
  dataSource1: any = [];
  pages = [20, 50, 100];
  filter:string;
  dataSource = new MatTableDataSource(this.dataSource1);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  active: string = 'true';

  constructor(private usersService: UsersService, public authService: AuthService, private dialog: MatDialog, private xlsxService: XlsxService, private notificationService: NotificationServiceService) { }

  ngOnInit(): void {
    this.userRolCheck2('permiso_total');
    this.loadingBar = true;
    this.prepareTable();
    this.getUsuarios();
  }

  userRolCheck2(permission: string){
    if(!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  userRolCheck(permission: string){
    return this.authService.userRolCheck(permission);
  }

  getUsuarios() {
    //Traemos los usuarios
    this.loadingBar = true;
    this.usersService.getUsuarios(this.active).subscribe(result => {
      this.loadingBar = false;
      this.dataSource1 = result;
      this.prepareTable();
    });
  }

  newUsuario() {
    const newUsuarioDialog = this.dialog.open(NewUserComponent, {
      width: '90%',
      maxWidth: '500px'
    });
    newUsuarioDialog.afterClosed().subscribe(result => {
      if(result){
        this.loadingBar = true;
        this.usersService.newUsuario(result[0]["name"], result[0]["surname"], result[0]["email"], result[0]["password"], result[0]["active"], result[0]["permiso_total"], result[0]["permiso_pesar"], result[0]["permiso_clasificar"]
                                      , result[0]["permiso_registros"], result[0]["permiso_registrosDatos"], result[0]["permiso_registrosPesos"], result[0]["permiso_usuarios"], result[0]["permiso_contenedores"]
                                      , result[0]["permiso_contenedores_alta_movimientos"], result[0]["permiso_contenedores_alta_mantenimientos"]).subscribe(() => {
          this.loadingBar = false;
          this.notificationService.openSnackBar("¡Usuario creado correctamente!");
          this.getUsuarios();
        });
      }
    });
  }

  editUsuario(id:number) {
    for (var i = 0; i < this.dataSource1.length; i++) {
      if(this.dataSource1[i]["id"] === id){
        const modifDialog = this.dialog.open(EditUserComponent, {
          data: {'id': this.dataSource1[i]["id"], 'name': this.dataSource1[i]["name"], 'surname' : this.dataSource1[i]["surname"], 'email' : this.dataSource1[i]["email"], 'active' : this.dataSource1[i]["active"],
                  'permiso_total' : this.dataSource1[i]["permiso_total"], 'permiso_pesar' : this.dataSource1[i]["permiso_pesar"], 'permiso_clasificar' : this.dataSource1[i]["permiso_clasificar"]
                  , 'permiso_registros' : this.dataSource1[i]["permiso_registros"], 'permiso_registrosDatos' : this.dataSource1[i]["permiso_registrosDatos"], 'permiso_registrosPesos' : this.dataSource1[i]["permiso_registrosPesos"]
                  , 'permiso_usuarios' : this.dataSource1[i]["permiso_usuarios"], 'permiso_contenedores' : this.dataSource1[i]["permiso_contenedores"], 'permiso_contenedores_alta_movimientos' : this.dataSource1[i]["permiso_contenedores_alta_movimientos"]
                  , 'permiso_contenedores_alta_mantenimientos' : this.dataSource1[i]["permiso_contenedores_alta_mantenimientos"]},
          width: '90%',
          maxWidth: '500px'
        });
        modifDialog.afterClosed().subscribe(result => {
          if(result){
            this.loadingBar = true;
            this.usersService.editUsuarioAdmin(id, result[0]["name"], result[0]["surname"], result[0]["email"], result[0]["active"], result[0]["permiso_total"], result[0]["permiso_pesar"], result[0]["permiso_clasificar"]
                                          , result[0]["permiso_registros"], result[0]["permiso_registrosDatos"], result[0]["permiso_registrosPesos"], result[0]["permiso_usuarios"], result[0]["permiso_contenedores"]
                                          , result[0]["permiso_contenedores_alta_movimientos"], result[0]["permiso_contenedores_alta_mantenimientos"], result[0]["scale_ids"] || []).subscribe(() => {
              this.loadingBar = false;
              this.notificationService.openSnackBar("¡Usuario modificado correctamente!");
              this.getUsuarios();
            });
          }
        });
        break;
      }
    }
  }

  editPasswordUsuario(id: number){
    const modifDialog = this.dialog.open(EditUserPasswordComponent, {
      width: '90%',
      maxWidth: '350px'
    });
    modifDialog.afterClosed().subscribe(result => {
      if(result){
        this.loadingBar = true;
        this.usersService.editUsuarioPassword(id, result["password"]).subscribe(() => {
          this.loadingBar = false;
          this.notificationService.openSnackBar("¡Contraseña modificada correctamente!");
          this.getUsuarios();
        });
      }
    });
  }

  deleteUsuario(id:number){
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar Usuario', body: '¿Seguro que deseas eliminar este usuario?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.loadingBar = true;
        this.usersService.deleteUsuario(id).subscribe(() => {
          this.loadingBar = false;
          this.notificationService.openSnackBar("¡Usuario eliminado correctamente!");
          this.getUsuarios();
        });
      }
    });
  }

  prepareTable() {
    this.dataSource = new MatTableDataSource(this.dataSource1);
    this.paginator._intl.itemsPerPageLabel = 'Usuarios por página:';
    this.filter = '';
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveExcel() {
    const data = this.dataSource.data;
    const excelData = data.map(item => ({
      'Nombre': item['name'],
      'Apellidos': item['surname'],
      'Email': item['email'],
      'Estado': item['active'],
    }));
    this.xlsxService.saveExcelData(excelData, 'Usuarios');
  }

}